// para modificar una modalidad de torneo
export const SET_TEAM = 'SET_TEAM'
